import { Box, Divider, Grid2 as Grid, Tooltip, Typography } from '@mui/material'
import {
  MenuBookOutlined,
  OpenInNew,
  UploadFileOutlined
} from '@mui/icons-material'
import { DiagnosticsFilters, DiagnosticsTable } from './components'
import { useDiagnosticList } from './hooks/useDiagnosticsList'
import ButtonBase from 'design-system/button'
import NavLinkBase from 'design-system/NavLink'
import { DIAGNOSTICS_UPLOAD } from 'navigation/CONSTANTS'
import { DiagnosticsListConfig } from '../types'
import analytics from 'services/analytics'
import { useEffect } from 'react'

interface DiagnosticsListViewProps {
  config: DiagnosticsListConfig
}

const DiagnosticsListView = ({ config }: DiagnosticsListViewProps) => {
  const {
    filteredDiagnostics,
    filters,
    handleFilterChange,
    applyFilters,
    clearFilters,
    handleRowClick,
    isLoading,
    paginationModel,
    handlePaginationChange,
    totalCount,
    sortModel,
    handleSortModelChange,
    resetSort,
    hasCustomSort
  } = useDiagnosticList(config)

  useEffect(() => {
    if (config.examType === 'cxray') {
      analytics.track('xray_page_viewed', { page: 'list' })
    }
  }, [config.examType])

  return (
    <Box display='flex' sx={{ justifyContent: 'center' }}>
      <Grid container spacing={2} flex={1} maxWidth='1200px' p={2}>
        <Grid
          size={12}
          display='flex'
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography variant='h5' display='flex' alignItems='center' gap={1}>
            {config.icon} {config.title}
          </Typography>
          <Box display='flex' alignItems='center' gap={1}>
            {config.manualHref && (
              <Tooltip title={config.manualTooltip ?? 'Manual de uso'}>
                <ButtonBase
                  variant='outlined'
                  onClick={() =>
                    window.open(
                      config.manualHref,
                      '_blank',
                      'noopener,noreferrer'
                    )
                  }
                >
                  <MenuBookOutlined />
                  <Typography variant='body1'>Manual de uso</Typography>
                  <OpenInNew fontSize='small' />
                </ButtonBase>
              </Tooltip>
            )}
            <NavLinkBase
              to={`${config.basePath}/${DIAGNOSTICS_UPLOAD}`}
              absolute
            >
              <ButtonBase>
                <UploadFileOutlined />
                <Typography variant='body1'>Enviar exame</Typography>
              </ButtonBase>
            </NavLinkBase>
          </Box>
        </Grid>
        <Grid size={12} display='flex' flexDirection='column' gap={2} mb={2}>
          <DiagnosticsFilters
            filters={filters}
            examType={config.examType}
            onFilterChange={handleFilterChange}
            onApplyFilters={applyFilters}
            onClearFilters={clearFilters}
          />
          <Divider sx={{ my: 3 }} />
          <Grid size={12}>
            <DiagnosticsTable
              data={filteredDiagnostics}
              onRowClick={handleRowClick}
              examType={config.examType}
              basePath={config.basePath}
              loading={isLoading}
              paginationModel={paginationModel}
              onPaginationChange={handlePaginationChange}
              totalCount={totalCount}
              sortModel={sortModel}
              onSortModelChange={handleSortModelChange}
              hasCustomSort={hasCustomSort}
              onResetSort={resetSort}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default DiagnosticsListView
